import { render, staticRenderFns } from "./contentClient.vue?vue&type=template&id=61b71e5d&"
import script from "./contentClient.vue?vue&type=script&lang=js&"
export * from "./contentClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports